import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";
import parallaxStyle from "assets/jss/material-kit-pro-react/components/parallaxStyle.js";
import {
  container,
  mrAuto,
  title,
  blackColor,
  whiteColor,
  hexToRgb,
  infoColor
} from "assets/jss/material-kit-pro-react.js";

const headersSection = theme => ({
  ...headerLinksStyle(theme),
  sectionBlank: {
    height: "70px",
    display: "block"
  },
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
    "& h1, & h4, & h6": {
      color: whiteColor
    }
  },
  conatinerHeader2: {
    ...container,
    zIndex: "2",
    position: "relative",
    "& h1, & h4, & h6": {
      color: whiteColor
    },
    paddingTop: "25vh"
  },
  title,
  pageHeader: {
    position: "relative",
    height: "100vh",
    maxHeight: "1600px",
    backgroundPosition: "center bottom",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    WebkitBoxAlign: "center",
    MsFlexAlign: "center",
    alignItems: "center",
    "&:before": {
      background: "rgba(" + hexToRgb(blackColor) + ", 0)"
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  iframeContainer: {
    "& > iframe": {
      width: "100%",
      boxShadow:
        "0 16px 38px -12px rgba(" +
        hexToRgb(blackColor) +
        ", 0.56), 0 4px 25px 0px rgba(" +
        hexToRgb(blackColor) +
        ", 0.12), 0 8px 10px -5px rgba(" +
        hexToRgb(blackColor) +
        ", 0.2)"
    }
  },
  mrAuto,
  textCenter: {
    textAlign: "center"
  },
  card: {
    marginTop: "60px"
  },
  formControl: {
    margin: "0",
    padding: "8px 0 0 0"
  },
  textRight: {
    textAlign: "right"
  },
  button: {
    margin: "0 !important"
  },
  logoImg: {
    display: "block",
    margin: `0px auto!important`,
    padding: 0
  },
  logoWrapper: {
    width: 700,
    height: `${window.innerWidth > 900 ? "70px" : "270px"}!important`,
    maxWidth: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  logoTitle: {
    float: `${window.innerWidth > 900 ? "left" : false}!important`,
    color: infoColor[0],
    margin: `0px 0px!important`,
    fontSize: `${window.innerWidth > 900 ? "60px" : "35px"}!important`,
    fontFamily: `"Sugar Snow", "Arial", sans-serif`,
    fontWeight: 400,
    lineHeight: "1.5em"
  },
  clear: {
    clear: "both"
  },
  ...parallaxStyle
});

export default headersSection;
